module.exports = __webpack_public_path__ + "static/media/plan.a23d9ff4.svg";